// extracted by mini-css-extract-plugin
export default {"row--applied":"DiscountsHistoryModal_row--applied__uLd4D","row--expired":"DiscountsHistoryModal_row--expired__eUjcs","row--added":"DiscountsHistoryModal_row--added__Umnno"};